export function redirectTo(url: any) {
  window.location = url;
}
